import { useEffect, useState } from "react"
import axios from 'axios'
import * as Yup from 'yup';
import { useFormik } from 'formik'
import { useToast } from '../../toastHook'
import { errorCss } from '../Utils/formik-util';
import { areArraySame } from '../../utils/comparer'
import { extractNumberFromInput  } from '../../utils/inputUtils'

export const EditLastSincePenaliteComponent = ({ value, setter, setIsValid, setGlobalErrorMessage, titreYear }) => {

    const [cssErrors, setCssErrors ] = useState([]);

    const getCssError = (index_1, index_2) =>
    {
        if (cssErrors.length > index_1) {
            return cssErrors[index_1][index_2];
        }
        else {
            return "";
        }
    }

    useEffect(() => {
        let globalErrorMessage = "";
        let cssErrors = Array.from({ length: value.length }, () => ["", ""] );

        for (var index = 1; index < value.length; index++) {
            if (value[index][0] <= value[index - 1][0]) {
                globalErrorMessage = "les années d'arrêt d'activité doivent être croissante";
            }

            if (value[index][1] >= value[index - 1][1]) {
                globalErrorMessage = "les coefficients doivent être décroissants";
            }
        }

for (var index = 0; index < value.length; index++) {
            if (typeof value[index][0] !== 'number') {
                cssErrors[index][0] = "l'année etre un nombre"
            }

            if (value[index][0] < 0) {
                cssErrors[index][0] = "l'année d'arrêt d'activité doit être supérieure à 0";
            }

            if (typeof value[index][1] !== 'number') {
                cssErrors[index][1] = 'la pénalité doit etre un nombre'
            }

            if (value[index][1] < 0) {
                cssErrors[index][1] = "la pénalité doit être supérieure à 0";
            }

            if (value[index][1] >= 1) {
                cssErrors[index][1] = "la pénalité doit être inférieure à 1";
            }

        }

        setGlobalErrorMessage(globalErrorMessage);
        setCssErrors(cssErrors);

        let isValid = !cssErrors.find(x => x[0] || x[1]) && !globalErrorMessage
        setIsValid(isValid);

    }, [value]);

    const handleInputChange = (index_0, index_1, event) => {
        const v = value.map(x => [...x]);
        v[index_0][index_1] = extractNumberFromInput(event.target);

        setter(v);
    }

    const addRow = () => {
        const v = value.map(x => [...x]);
        v.push([0, 0]);
        setter(v);
    }

    const deleteRow = index => {
        setter(value.filter((x, i) => i !== index));
    }

    return <div>
        <table className="table">
            <thead>
                <tr><th scope="col">{ titreYear }</th>
                    <th scope="col">Pénalité</th>
                    <th><i className="pi pi-plus text-success" onClick={ addRow } ></i></th>
                </tr>
            </thead>
            <tbody>
                {value.map((x,i) => 
                    <tr>
                        <td>
                            <input type="number" step="0.0001" className={`form-control ${errorCss(getCssError(i,0))}`} placeholder="nombre d'année d'xp pour la pénalité" value={x[0]} onChange={e => handleInputChange(i, 0, e)} />
                            {getCssError(i, 0) ? (
                            <div className="invalid-feedback">{getCssError(i, 0)}</div>
                            ) : (<></>)}</td>
                            <td>
                        <input type="number" step="0.0001" className={`form-control ${errorCss(getCssError(i,1))}`} placeholder="nombre d'année d'xp pour la pénalité" value={x[1]} onChange={e => handleInputChange(i, 1, e)} />
                            {getCssError(i, 1) ? (
                            <div className="invalid-feedback">{getCssError(i, 1)}</div>
                            ) : (<></>)}</td>
                        <td><i className="pi pi-trash text-danger" onClick={ () => deleteRow(i) } ></i></td>
                    </tr>
                ) }
            </tbody>
        </table>
    </div>
}


export const EditMatriceNiveauxComponent = ({ value, setter, setIsValid }) => {

    const [valuesErrors, setValuesError] = useState([]);

    const niveaux = [-1, 3, 4, 5];

    const getNiveauLabel = niveau => {
        switch (niveau) {
            case -1:
                return "inconnnu";
            case 3:
                return "moyen";
            case 4:
                return "maîtrise";
            case 5:
                return "expert";
        }
    }

    const getValue =  (niveau, array) => {
        const foundValue = array.find(x => areArraySame(x.slice(0, 2), niveau));

        if (!Array.isArray(foundValue) ||  foundValue.length !== 3 ) {
            return undefined;
        }

        return foundValue[2];
    }

    const createValuesWithNewValue = (valuesArray, niveau, newValue) =>
    {
        let newArray = [];

        for (var index = 0; index < valuesArray.length; index++) {
            if (!Array.isArray(valuesArray[index]) || valuesArray[index].length !== 3) {
                continue;
            }

            let x = valuesArray[index]
            if (areArraySame(x.slice(0, 2), niveau)) {
                newArray.push([...x.slice(0, 2), newValue]);
            }
            else {
                newArray.push([...x]);
            }
        }

        return newArray;
    }


    useEffect(() => {
        handleErrors();
    }, [value])

    const handleErrors = () => {

        let errors = [];
        let globalError = undefined;

        niveaux.forEach(x => { 
            niveaux.forEach(y => {
                let v = getValue([x, y], value);
            let error = undefined;

           if (!v && v !== 0) {
                error = 'la valeur est requise';
                }

            if (v < 0) {
                error = 'la valeur doit être supérieur à 0';
            }

                if (typeof v !== 'number' ) {
                    error = 'la valeur doit etre un nombre'
                }

            if (error) {
                globalError = "la matrice de niveau est incorrecte"
                }

                errors.push([x, y, error]);
            })
        })

        setValuesError(errors);
        setIsValid(!globalError);

    }

    const handleInputChange = (x, y, event) => {

        let inputValue = extractNumberFromInput(event.target);
        const newValue = value.map(z => {
            if (areArraySame(z.slice(0, 2), [x, y])) {
                return [x, y, inputValue]
            }
            else {
                return z;
            }
        })

        setter(newValue);
    }

    if (!value) {
        return <div>loading ...</div>
    }

    return <div>
        <table className="table">
            <thead>
                <tr><th scope="col">#</th>
                {
                        niveaux.map(x => <th key={"titleColumn-" + x} scope="col" >{getNiveauLabel(x)}</th>)
                    }
                </tr>
            </thead>
            <tbody>
                {niveaux.map(x => <tr key={"row-" + x} >
                    <th scope="row">{getNiveauLabel(x)}</th>
                    {niveaux.map(y => <td> 
                        <input type="number" step="0.0001" className={`form-control ${errorCss(getValue([x, y], valuesErrors))}`} placeholder={ "(" + getNiveauLabel(x) + "," + getNiveauLabel(y) + ")" } value={getValue([x,y], value)} onChange={e => handleInputChange(x,y,e)} />
                        {getValue([x, y], valuesErrors) ? (
                            <div className="invalid-feedback">{getValue([x, y], valuesErrors)}</div>
                        ) : (<></>)}
                    </td>) }
                    </tr>)}
            </tbody>
        </table>
    </div>
}

export const EditPourcentageCompetenceMatchedBonusComponent = ({ value, setter, setIsValid, setGlobalErrorMessage }) => {

    const [errors, setErrors] = useState([]);

    useEffect(() => {
        var globalError = "";
        var newErrors = Array.from({ length: value.length }, () => { return { Min: "", Max: "", Bonus: "" } });

        if (value.length === 0 || value[0].Min !== 0) {
            globalError = "Le premier min doit être à 0";

            if (newErrors.length > 0) {
                newErrors[0].Min = "Le premier min doit être à 0"
            }
        }

        if (value.length === 0 || value[value.length - 1].Max != 100) {
            globalError = "Le dernier max doit être à 100";

            if (newErrors.length > 0) {
                newErrors[newErrors.length - 1].Max = "Le dernier max doit être à 100"
            }
        }

        for (var index = 1; index < value.length; ++index) {

            if (value[index - 1].Max !== value[index].Min) {
                newErrors[index - 1].Max = "d'une position n à n+1 Min doit être égale à Max"
                newErrors[index ].Min = "d'une position n à n+1 Min doit être égale à Max"
            }

            if (value[index - 1].Min >= value[index].Min) {
                newErrors[index - 1].Min = "Min doit être croissant"
                newErrors[index ].Min = "Min doit être croissant"
            }

            if (value[index - 1].Max >= value[index].Max) {
                newErrors[index - 1].Max = "Max doit être croissant"
                newErrors[index ].Max = "Max doit être croissant"
            }

            if (value[index - 1].Bonus >= value[index].Bonus) {
                newErrors[index - 1].Bonus = "Le bonus doit être croissant"
                newErrors[index].Bonus = "Le bonus doit être croissant"
            }


            if (value[index - 1].Bonus <= 0 ) {
                newErrors[index - 1].Bonus = "Le bonus doit être strictement positif"
            }

            if (value[index ].Bonus <= 0) {
                newErrors[index ].Bonus = "Le bonus doit être strictement positif"
            }
        }

        var isValid = !globalError && !newErrors.find(x => x.Min || x.Max || x.Bonus);
        setIsValid(isValid);

        setGlobalErrorMessage(globalError);
        setErrors(newErrors);

    }, [value])


    const addRow = () => {
        setter([...value, { Min: 0, Max: 0, Bonus: 0 }]);
    }

    const deleteRow = index => {
        setter(value.filter((x, i) => index !== i));
    }

    const getCssError = (index1, name) => {

        if (errors.length <= index1) {
            return "";
        }

        return errors[index1][name];

    }

    const handleInputChange = (index, name, event) => {
        var newValue = value.map(x => { return { ...x } });
        const inputValue = extractNumberFromInput(event.target);

        newValue[index][name] = inputValue;

        setter(newValue);
    }

    return <div>
        <table className="table">
            <thead>
                <tr><th scope="col">Min</th>
                    <th scope="col">Max</th>
                    <th scope="col">Bonus</th>
                    <th><i className="pi pi-plus text-success" onClick={addRow} ></i></th>
                </tr>
            </thead>
            <tbody>
                {value.map((x, i) =>
                    <tr key={ i }>
                        <td>
                            <input type="number" step="0.0001" className={`form-control ${errorCss(getCssError(i, "Min"))}`} placeholder="nombre d'année d'xp pour la pénalité" value={x.Min} onChange={e => handleInputChange(i, "Min", e)} />
                            {getCssError(i, "Min") ? (
                                <div className="invalid-feedback">{getCssError(i, "Min")}</div>
                            ) : (<></>)}</td>
                        <td>
                            <input type="number" step="0.0001" className={`form-control ${errorCss(getCssError(i, "Max"))}`} placeholder="nombre d'année d'xp pour la pénalité" value={x.Max} onChange={e => handleInputChange(i, "Max", e)} />
                            {getCssError(i, "Max") ? (
                                <div className="invalid-feedback">{getCssError(i, "Max")}</div>
                            ) : (<></>)}</td>
                        <td>
                            <input type="number" step="0.0001" className={`form-control ${errorCss(getCssError(i, "Bonus"))}`} placeholder="nombre d'année d'xp pour la pénalité" value={x.Bonus} onChange={e => handleInputChange(i, "Bonus", e)} />
                            {getCssError(i, "Bonus") ? (
                                <div className="invalid-feedback">{getCssError(i, "Bonus")}</div>
                            ) : (<></>)}</td>
                        <td><i className="pi pi-trash text-danger" onClick={() => deleteRow(i)} ></i></td>
                    </tr>
                )}
            </tbody>
        </table>
    </div>
}

export const MatchageScoringConstantesComponent = () => {
    const [constantes, setConstantes] = useState({});
    const [count, setCount] = useState(0);
    const { display } = useToast();
    const [isMatriceNiveauValid, setIsMatriceNiveauValid] = useState(false);
    const [isLastSincePenaliteValid, setIsLastSincePenaliteValid] = useState(false);
    const [isPourcentageMatchedBonusValid, setIsPourcentageMatchedBonusValid] = useState(false);
    const [isCompetencesPrincipalesLastSincePenaliteValid, setiIsCompetencesPrincipalesLastSincePenaliteValid] = useState("");
    const [lastSincePenaliteGlobaleErrorMessage, setLastSincePenaliteGlobaleErrorMessage] = useState("");
    const [competencesPrincipalesLastSincePenaliteErrorMessage, setCompetencesPrincipalesLastSincePenaliteErrorMessage] = useState("");
    const [pourcentageMatchedBonusValidErrorMessage, setPourcentageMatchedBonusValidErrorMessage] = useState("");

    const formikValidationSchema = Yup.object().shape({
        CoefficientExperience: Yup.number().min(0, 'doit être supérieur à 0').required(),
        CoefficientMoreThanExperiencePlus: Yup.number().min(1, 'doit être supérieur à 1').required(),
        CoefficientExperienceBloquante: Yup.number().min(0, 'doit être supérieur à 0').required()

    });

    const formik = useFormik({
        initialValues: constantes,
        validationSchema: formikValidationSchema,
        onSubmit: values => {

            if (!isMatriceNiveauValid || !isLastSincePenaliteValid || !isPourcentageMatchedBonusValid || !isCompetencesPrincipalesLastSincePenaliteValid) {
                return;
            }

            axios.post('/api/matchagescoringconfiguration', values)
                .then(response => {
                    if (response.status === 200) {
                        display({
                            titre: 'Constantes de matchage scoring mise à jour',
                            text: "Les constantes de matchages scoring vienne d'être mise à jours",
                            severity: 'success'
                        });

                        setCount(count + 1);
                    }
                    else {
                        display({
                            titre: 'Constantes de matchage non mise à jour',
                            text: "Impossible de mettre à jour les constantes de matchage",
                            severity: 'danger'
                        });
                    }
                })


        },
        enableReinitialize: true
    });

    useEffect(() => {
        axios.get("/api/matchagescoringconfiguration")
            .then(response => {
                if (response.data) {
                    setConstantes(response.data);
                }
            })
    }, [count]);

    if (!formik.values.MatriceNiveau || !formik.values.MatriceNiveau.MatriceNiveau) {
        return <div>loading ...</div>
    }

    return <div>
        <div className="alert alert-info">
            Voici la page de configuration des calculs de scoring de matchages
        </div>
        <form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
                <label htmlFor="CoefficientExperience" className="form-label">coefficient pour l'expérience</label>
                <input type="number" step="0.0001" className={`form-control ${errorCss(formik.errors.CoefficientExperience)}`} id="CoefficientExperience" name="CoefficientExperience" placeholder="Expérience" onChange={formik.handleChange} value={formik.values.CoefficientExperience} />
                {formik.errors.CoefficientExperience ? (
                    <div className="invalid-feedback">{formik.errors.CoefficientExperience}</div>
                ) : (<></>)}
            </div>
            <div className="mb-3">
                <label htmlFor="CoefficientMoreThanExperiencePlus" className="form-label">coefficient pour les expériences très grande (très supérieur à année +)</label>
                <input type="number" step="0.0001" className={`form-control ${errorCss(formik.errors.CoefficientMoreThanExperiencePlus)}`} id="CoefficientMoreThanExperiencePlus" name="CoefficientMoreThanExperiencePlus" placeholder="Nombre maximal de résultats matchés" onChange={formik.handleChange} value={formik.values.CoefficientMoreThanExperiencePlus} />
                {formik.errors.CoefficientMoreThanExperiencePlus ? (
                    <div className="invalid-feedback">{formik.errors.CoefficientMoreThanExperiencePlus}</div>
                ) : (<></>)}
            </div>
            <div className="mb-3">
                <label htmlFor="CoefficientExperienceBloquante" className="form-label">coefficient pour les expériences bloquantes</label>
                <input type="number" step="0.0001" className={`form-control ${errorCss(formik.errors.CoefficientExperienceBloquante)}`} id="CoefficientExperienceBloquante" name="CoefficientExperienceBloquante" placeholder="Nombre maximal de résultats matchés" onChange={formik.handleChange} value={formik.values.CoefficientExperienceBloquante} />
                {formik.errors.CoefficientExperienceBloquante ? (
                    <div className="invalid-feedback">{formik.errors.CoefficientExperienceBloquante}</div>
                ) : (<></>)}
            </div>
            <div className="mb-3">
                <label className="form-label">Pénalité pour années de dernière expérience de l'activité</label>
                {lastSincePenaliteGlobaleErrorMessage ? (
                    <div className="text-danger">{lastSincePenaliteGlobaleErrorMessage}</div>
                ) : (<></>)}
                <EditLastSincePenaliteComponent value={formik.values.LastSinceActivitePenalite.Penalites} setter={v => formik.setFieldValue("LastSinceActivitePenalite", { "Penalites": v })} setIsValid={isValid => setIsLastSincePenaliteValid(isValid)} setGlobalErrorMessage={message => setLastSincePenaliteGlobaleErrorMessage(message)} titreYear={ "années sans l'activité" } ></EditLastSincePenaliteComponent>
            </div>
            <div className="mb-3">
                <label className="form-label">Pénalité pour les compétences principales</label>
                {competencesPrincipalesLastSincePenaliteErrorMessage ? (
                    <div className="text-danger">{competencesPrincipalesLastSincePenaliteErrorMessage}</div>
                ) : (<></>)}
                <EditLastSincePenaliteComponent value={formik.values.CompetencePrincipalePenalite.Penalites} setter={v => formik.setFieldValue("CompetencePrincipalePenalite", { "Penalites": v })} setIsValid={isValid => setiIsCompetencesPrincipalesLastSincePenaliteValid(isValid)} setGlobalErrorMessage={message => setCompetencesPrincipalesLastSincePenaliteErrorMessage(message)} titreYear={"années sans la compétence principale"} ></EditLastSincePenaliteComponent>
            </div>
            <div className="mb-3">
                <label className="form-label">Bonus suivant le pourcentage de compétences matchées</label>
                {pourcentageMatchedBonusValidErrorMessage ? (
                    <div className="text-danger">{pourcentageMatchedBonusValidErrorMessage}</div>
                ) : (<></>)}
                <EditPourcentageCompetenceMatchedBonusComponent value={formik.values.PourcentageCompetencesMatchedBonus} setter={v => formik.setFieldValue("PourcentageCompetencesMatchedBonus", v)} setIsValid={isValid => setIsPourcentageMatchedBonusValid(isValid)} setGlobalErrorMessage={message => setPourcentageMatchedBonusValidErrorMessage(message)} ></EditPourcentageCompetenceMatchedBonusComponent>
            </div>
            <div className="mb-3">
                <label  className="form-label">Matrice de niveau</label>
                <EditMatriceNiveauxComponent value={formik.values.MatriceNiveau.MatriceNiveau} setter={v => formik.setFieldValue("MatriceNiveau", { "MatriceNiveau": v })} setIsValid={isValid => setIsMatriceNiveauValid(isValid) } ></EditMatriceNiveauxComponent>
            </div>
            <button type="submit" className="btn btn-success" >Valider</button>
        </form></div>
}






